import { useEffect } from "react";
import { useLocation } from "react-router";
import { Progress } from "flowbite-react";
import Logo from "../logo";
import CTA from "./cta";

export const StepContainer = ({
  children,
  stepNum,
  setStep,
  productError,
  progress,
  onCloseModal,
  showModal,
  languages,
}) => {
  const history = useLocation();

  useEffect(() => {
    setStep(stepNum);
  }, [history, stepNum, setStep]);

  return (
    <>
      <div
        className={`App structure font-montserrat ${
          productError || stepNum === 5 ? "gray" : ""
        }`}
      >
        <Logo />
        {/* <ErrorBoundary> */}
        <div className="progress-bar">
          <Progress className="progressbar" progress={progress} />
        </div>
        <div
          className={`${
            productError || stepNum === 5 ? "gray-body" : ""
          } container mx-auto xs:px-3.5 laptop:px-4`}
        >
          {/* <Button onClick={handleShowModal}>
              Toggle modal
              </Button> */}

          <div className="register-wrapper">
            {/* <div className='progress-bar'>
                    <Progress className='progressbar' progress={progress} />
                  </div> */}

            {/* <Header 
                    goPreviousStep  = {goPreviousStep}
                    step            = {step}
                    headerText      = {headerText}
                    languages       = {languages}
                    productError    = {productError}
                    handleShowModal = {handleShowModal}
                    isUserLogged    = {isUserLogged}
                    locationDatas   = {locationDatas}
                  /> */}

            {/* {isLoaded && isProductLoaded && benefitLanguageLoad ? ( */}

            <div className="dynamic-component xs:pt-2 tablet:pt-4">
              {children}
            </div>

            {/* {step === 11 ? null :
                        <StickyFooter 
                          isProcessing                    = {isProcessing}
                          goNextStep                      = {goNextStep}
                          confirmOrder                    = {confirmOrder}
                          storeMembershipData             = {storeMembershipData}
                          currentStep                     = {step}
                          products                        = {products} //[Primary] 
                          secondaryProducts               = {secondaryProducts} // [Secondary]
                          checkBoxTerms                   = {checkBoxTerms} // [Step] - Review
                          reviewLoading                   = {reviewLoading} // [Step] - Review
                          checkBoxTermsQBR                = {checkBoxTermsQBR} // [Step] - Review
                          QBRLoading                      = {QBRLoading}
                          confirmValidateQBR              = {confirmValidateQBR}
                          validateQbr                     = {validateQbr}
                          memberStatus                    = {memberStatus} // [Step] - Personal Details
                          personalDetailsSubmit           = {personalDetailsSubmit} // [Step] Personal 
                          onMouseHover                    = {onMouseHover}
                          onMouseLeave                    = {onMouseLeave}
                          // onSubmitAddressDetails          = {onSubmitAddressDetails} // [Step] Primary Address
                          // onSubmitSecondaryAddressDetails = {onSubmitSecondaryAddressDetails} // [Step] Secondary Address
                          languages                       = {languages}
                        />
                        } */}
          </div>
        </div>
        {/* </ErrorBoundary> */}
      </div>
      <CTA
        onCloseModal={onCloseModal}
        showModal={showModal}
        languages={languages}
      />
    </>
  );
};
